import { Redirect, router } from 'expo-router';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import { BodyMediumRegular, ScreenContainer, YStack } from 'smoothie';

import useShouldSeeIncomeSplit from '../../hooks/income-split/useShouldSeeIncomeSplit';
import useGetAllBankAccountDetails from '../../hooks/useGetAllBankAccountDetails';
import {
    detectedPaychecksAtom,
    existingPaycheckRoutingConfigsAtom,
} from '../../state/PaycheckRoutingAtoms';
import { bankAccountDisplayDetails } from '../../state/SpacesAtoms';
import { BankDisclosureShortFootnote } from '../Disclosures';
import DetectedIncomeCard from './common/DetectedIncomeCard';
import { findMatchingRoutingConfigForPaycheck } from './helpers';

const AccountDetection = () => {
    const detectedPaychecks = useAtomValue(detectedPaychecksAtom);
    const accountDisplayDetails = useAtomValue(bankAccountDisplayDetails);
    const { closedAccountDetails } = useGetAllBankAccountDetails(false);
    const allAccountDetails = [
        ...accountDisplayDetails,
        ...closedAccountDetails,
    ];

    const existingPaycheckRoutingConfigs = useAtomValue(
        existingPaycheckRoutingConfigsAtom,
    );

    const shouldSeeIncomeSplit = useShouldSeeIncomeSplit();

    if (shouldSeeIncomeSplit) {
        return <Redirect href="/home/banking" />;
    }

    detectedPaychecks.sort((a, b) => {
        const aHasExistingPaycheckRoutingConfig =
            findMatchingRoutingConfigForPaycheck(
                a,
                existingPaycheckRoutingConfigs,
            );
        const bHasExistingPaycheckRoutingConfig =
            findMatchingRoutingConfigForPaycheck(
                b,
                existingPaycheckRoutingConfigs,
            );
        if (
            aHasExistingPaycheckRoutingConfig &&
            bHasExistingPaycheckRoutingConfig
        ) {
            return 0;
        } else if (
            aHasExistingPaycheckRoutingConfig &&
            !bHasExistingPaycheckRoutingConfig
        ) {
            return 1;
        } else if (
            bHasExistingPaycheckRoutingConfig &&
            !aHasExistingPaycheckRoutingConfig
        ) {
            return -1;
        } else {
            return 0;
        }
    });
    return (
        <ScreenContainer
            title="Your paychecks"
            hasBackButton
            onFallbackRoute="/home/banking"
            onBack={() => {
                router.navigate('/home/banking');
            }}
        >
            <YStack gap={24} justifyContent="space-between">
                <YStack gap={24}>
                    <BodyMediumRegular color="$gray1000">
                        These are the most recent deposits we&apos;ve found
                        eligible for paycheck split
                    </BodyMediumRegular>
                    <YStack gap={16}>
                        {detectedPaychecks.map((paycheck, index) => {
                            const bankAccountDetails = allAccountDetails.find(
                                (account) => {
                                    return (
                                        account.bankAccountId ===
                                        paycheck.accountId
                                    );
                                },
                            );
                            if (!bankAccountDetails) return null;

                            return (
                                <DetectedIncomeCard
                                    isOverview
                                    key={`${paycheck.accountId}-${index}`}
                                    income={paycheck}
                                    bankAccountDetails={bankAccountDetails}
                                    showSetupButton={true}
                                />
                            );
                        })}
                    </YStack>
                </YStack>

                <BankDisclosureShortFootnote />
            </YStack>
        </ScreenContainer>
    );
};

export default AccountDetection;
